export const prodConfigs = {
    serverUrl: process.env.REACT_APP_SERVER_URL
}